module.exports = __webpack_public_path__ + "static/img/sz.581c1bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sz.jpg
// module id = 8L/j
// module chunks = 1